<template>
  <v-dialog
    v-model="show"
    max-width="1400"
    persistent
  >
    <v-card>
      <v-card-title class="headline">{{$t("message.dialog.title.inputConfirm", "ja")}}</v-card-title>
      <v-card-text>{{$t("message.dialog.desc.inputConfirm", "ja")}}</v-card-text>
      <v-card-text v-if="isNotIncludesEmbeddedString"><div v-pre>本文に埋め込み文字列～{{COMPANY}}, {{NAME}}～は含まれていません。</div></v-card-text>
      <v-container v-if="optionForm">

        <!-- 配信元（From） -->
        <v-row justify="center">
          <v-col cols="4" md="4">
            <mp-label>{{$t("message.admin.sendmail.label.from")}}</mp-label>
          </v-col>
          <v-col cols="8" md="6" class="confirm-line">
            <mp-input-box>{{ optionForm.from }}</mp-input-box>
          </v-col>
        </v-row>

        <!-- 利用サービス -->
        <v-row justify="center">
          <v-col cols="4" md="4">
            <mp-label>{{$t("message.admin.sendmail.label.services")}}</mp-label>
          </v-col>
          <v-col cols="8" md="6" class="confirm-line">
            <mp-input-box>
              <ul class="serviceList">
                <li v-for="s in serviceNameList" :key="s">
                  {{ s }}
                </li>
              </ul>
            </mp-input-box>
          </v-col>
        </v-row>

        <!-- 所属 -->
        <v-row justify="center">
          <v-col cols="4" md="4">
            <mp-label>{{$t("message.admin.sendmail.label.group")}}</mp-label>
          </v-col>
          <v-col cols="8" md="6" class="confirm-line">
            <mp-input-box>{{ groupLargeName }}<span class="mx-2">＞</span>{{ groupSmallNameList }}</mp-input-box>
          </v-col>
        </v-row>

        <!-- 会社 -->
        <v-row justify="center">
          <v-col cols="4" md="4">
            <mp-label>{{ companyLabel.ja }}</mp-label>
          </v-col>
          <v-col cols="8" md="6" class="confirm-line">
            <mp-input-box>{{ companyNameList }}</mp-input-box>
          </v-col>
        </v-row>

        <!-- 都道府県 -->
        <v-row justify="center">
          <v-col cols="4" md="4">
            <mp-label>{{$t("message.admin.sendmail.label.prefCd")}}</mp-label>
          </v-col>
          <v-col cols="8" md="6" class="confirm-line">
            <mp-input-box>{{ prefCdNameList }}</mp-input-box>
          </v-col>
        </v-row>

        <!-- 宛先（To） -->
        <v-row justify="center">
          <v-col cols="4" md="4">
            <mp-label>{{$t("message.admin.sendmail.label.cc")}}</mp-label>
          </v-col>
          <v-col cols="8" md="6" class="confirm-line pr-0">
            <mp-input-box>{{ optionForm.cc }}</mp-input-box>
          </v-col>
        </v-row>

        <!-- 件名 -->
        <v-row justify="center">
          <v-col cols="4" md="4">
            <mp-label>{{$t("message.admin.sendmail.label.subject")}}</mp-label>
          </v-col>
          <v-col cols="8" md="6" class="confirm-line pr-0">
            <mp-input-box>{{ optionForm.subject }}</mp-input-box>
          </v-col>
        </v-row>

        <!-- 本文 -->
        <v-row justify="center">
          <v-col cols="4" md="4">
            <mp-label>{{$t("message.admin.sendmail.label.body")}}</mp-label>
          </v-col>
          <v-col cols="8" md="6" class="confirm-line pr-0">
            <mp-multiple-lines-input-box>{{ optionForm.body }}</mp-multiple-lines-input-box>
          </v-col>
        </v-row>

      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <mp-button min class="btn-half-wide" @click="handleClickCancel">{{$t("message.dialog.button.cancel", "ja")}}</mp-button>
        <v-spacer></v-spacer>
        <mp-button min class="btn-half-wide" @click="handleClickOk">{{$t("message.dialog.button.ok", "ja")}}</mp-button>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// import constantValue from '@/constantValue'
import MpLabel from '@/components/item/MpLabel.vue'
import MpInputBox from '@/components/item/MpInputBox.vue'
import MpButton from '@/components/item/MpButton.vue'
import MpMultipleLinesInputBox from '@/components/item/MpMultipleLinesInputBox.vue'

export default {
  components: {
    MpLabel,
    MpInputBox,
    MpButton,
    MpMultipleLinesInputBox
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    optionForm: {
      type: Object,
      default: null
    },
    service: {
      type: Array,
      default: null
    },
    group: {
      type: Array,
      default: null
    },
    company: {
      type: Array,
      default: null
    },
    companyLabel: {
      type: Object,
      default: () => { return { ja: '' } }
    },
    prefCd: {
      type: Array,
      default: null
    }
  },
  computed: {
    serviceNameList () {
      const res = []
      for (const s of this.service) {
        if (this.optionForm.services.includes(s.serviceId)) {
          res.push(s.serviceName.ja)
        }
      }
      return res
    },
    groupLargeName () {
      for (const g of this.group) {
        if (g.groupLargeId === this.optionForm.groupLargeId) {
          return g.groupLargeName.ja
        }
      }
      return ''
    },
    groupSmallNameList () {
      if (this.optionForm.groupSmallId.length === 0) {
        return '（すべて）'
      }
      const res = []
      for (const g of this.group) {
        if (g.groupLargeId === this.optionForm.groupLargeId) {
          for (const sg of g.groupSmallList) {
            if (this.optionForm.groupSmallId.includes(sg.groupSmallId)) {
              res.push(sg.groupSmallName.ja)
            }
          }
        }
      }
      return res.join(',')
    },
    companyNameList () {
      const res = []
      for (const c of this.company) {
        if (this.optionForm.companyId.includes(c.companyId)) {
          res.push(c.companyName)
        }
      }
      return res.join(',')
    },
    prefCdNameList () {
      const res = []
      for (const s of this.prefCd) {
        // if (this.optionForm.prefCd.includes(s)) {
        res.push(this.$store.getters.prefNameByCode(s).ja)
        // }
      }
      return res.join(',')
    },
    isNotIncludesEmbeddedString () {
      // return (this.optionForm.body.match(/{{(COMPANY|NAME)}}/) ? false : true)
      if (this.optionForm.body.match(/{{(COMPANY|NAME)}}/)) {
        return false
      } else {
        return true
      }
    }
  },
  methods: {
    // OKクリック時
    handleClickOk (ev) {
      // 親のclickOkを呼び出し
      this.$emit('clickOk', ev)
    },
    // キャンセルクリック時
    handleClickCancel (ev) {
      // 親のclickCancelを呼び出し
      this.$emit('clickCancel', ev)
    }
  }
}
</script>

<style scoped>
.confirm-line {
  border-bottom: solid 1px rgba(0, 0, 0, 0.33);
}
.btn-half-wide {
  width: 45%;
}
</style>
